import { Col, Form, Row } from "react-bootstrap";
import { ClientGeneralParams } from "../../types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import '../GeneralParams.css'

interface DemandModuleParamsFormProp {
    updateField: (field: keyof ClientGeneralParams, value: any) => void
}

export default function DemandModuleParamsForm({ updateField }: DemandModuleParamsFormProp) {
    const { t } = useTranslation(['clientParams']);
    const clientParams = useSelector((state: RootState) => state.clientParamsForm.data);
    const errors = useSelector((state: RootState) => state.clientParamsForm.errors);

    return (
        <Form>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column md={6}>{t("clientParams:form.claimEmailSubjectLabel")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("common:text")}</Form.Label>
                    <Form.Control
                        value={clientParams.claimEmailSubject ?? ""}
                        onChange={(e) => updateField("claimEmailSubject", e.target.value)}
                        isInvalid={!!errors?.claimEmailSubject}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.claimEmailSubject}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-5">
                <Form.Label column md={6}>{t("clientParams:form.claimEmailBodyLabel")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("common:text")}</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={5}
                        value={clientParams.claimEmailBody ?? ""}
                        onChange={(e) => updateField("claimEmailBody", e.target.value)}
                        isInvalid={!!errors?.claimEmailBody}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.claimEmailBody}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-5">
                <Form.Label column md={6}>{t("clientParams:form.claimProfessionalResponseTemplateLabel")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("common:text")}</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={12}
                        value={clientParams.claimProfessionalResponseTemplate ?? ""}
                        onChange={(e) => updateField("claimProfessionalResponseTemplate", e.target.value)}
                        isInvalid={!!errors?.claimProfessionalResponseTemplate}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.claimProfessionalResponseTemplate}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-5">
                <Form.Label column md={6}>{t("clientParams:form.claimHoursToResponseComment")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("common:numberInHours")}</Form.Label>
                    <Form.Control
                        type="number"
                        value={clientParams.claimHoursToDeleteComment  ?? ""}
                        onChange={(e) => updateField("claimHoursToDeleteComment", e.target.value)}
                        isInvalid={!!errors?.claimHoursToResponseComment}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.claimHoursToResponseComment}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-5">
                <Form.Label column md={6}>{t("clientParams:form.claimHoursToEditComment")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("common:numberInHours")}</Form.Label>
                    <Form.Control
                        type="number"
                        value={clientParams.claimHoursToEditComment  ?? ""}
                        onChange={(e) => updateField("claimHoursToEditComment", e.target.value)}
                        isInvalid={!!errors?.claimHoursToEditComment}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.claimHoursToEditComment}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            
            <Form.Group as={Row} className="mb-3">
                <Form.Label column md={6}>{t("clientParams:form.claimPatientEmailSubject")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("common:text")}</Form.Label>
                    <Form.Control
                        value={clientParams.claimPatientEmailSubject ?? ""}
                        onChange={(e) => updateField("claimPatientEmailSubject", e.target.value)}
                        isInvalid={!!errors?.claimPatientEmailSubject}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.claimPatientEmailSubject}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-5">
                <Form.Label column md={6}>{t("clientParams:form.claimPatientEmailBody")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("common:text")}</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={5}
                        value={clientParams.claimPatientEmailBody ?? ""}
                        onChange={(e) => updateField("claimPatientEmailBody", e.target.value)}
                        isInvalid={!!errors?.claimPatientEmailBody}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.claimPatientEmailBody}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3 mt-4 d-flex align-items-center" controlId="notifyIfExportRequests">
                <Form.Label column md={6}>{t("clientParams:form.notifyIfExportRequests")}</Form.Label>
                <Col md={6}>
                    <Form.Check
                        label={`${t("common:yes")} / ${t("common:no")}`}
                        checked={clientParams.notifyIfExportRequests ?? false}
                        onChange={(e) => updateField("notifyIfExportRequests", e.target.checked)}
                        isInvalid={!!errors?.notifyIfExportRequests}
                        type="checkbox"/>
                    <Form.Control.Feedback type="invalid">
                        {errors?.notifyIfExportRequests}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-5">
                <Form.Label column md={6}>{t("clientParams:form.numberOfExportedRequestsForNotify")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("common:number")}</Form.Label>
                    <Form.Control
                        type="number"
                        value={clientParams.numberOfExportedRequestsForNotify  ?? ""}
                        onChange={(e) => updateField("numberOfExportedRequestsForNotify", e.target.value)}
                        isInvalid={!!errors?.numberOfExportedRequestsForNotify}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.numberOfExportedRequestsForNotify}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3 mt-4 d-flex align-items-center" controlId="isRequiredResponsibleOnClaimClosure">
                <Form.Label column md={6}>{t("clientParams:form.isRequiredResponsibleOnClaimClosure")}</Form.Label>
                <Col md={6}>
                    <Form.Check
                        label={`${t("common:yes")} / ${t("common:no")}`}
                        checked={clientParams.isRequiredResponsibleOnClaimClosure ?? false}
                        onChange={(e) => updateField("isRequiredResponsibleOnClaimClosure", e.target.checked)}
                        isInvalid={!!errors?.isRequiredResponsibleOnClaimClosure}
                        type="checkbox" />
                    <Form.Control.Feedback type="invalid">
                        {errors?.isRequiredResponsibleOnClaimClosure}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
        </Form>
    );
}